module.exports = __webpack_public_path__ + "static/media/bg_img.2894f332.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/CasePeriod/imgs/bg_img.png
// module id = 314
// module chunks = 0